import { combineReducers } from 'redux';
import ChildrenEntity from './entities/children';
import StaffEntity from './entities/staff';
const entities = [ChildrenEntity, StaffEntity];
export const entityEpics = entities.map(entity => entity.epics);
const entityReducersObj = entities.reduce((acc, entity) => {
    return {
        ...acc,
        [entity.domain]: entity.reducer,
    };
}, {});
export const entityReducer = combineReducers(entityReducersObj);
